 
<div style="text-align: center; margin: auto; width: 100%;">
    <ngx-doc-viewer [url]="path_file" viewer="url" style="width:100%;height:60vh;"></ngx-doc-viewer>
</div>
 